<template>
  <div id="sidebar">
    <ul>
      <testimonial v-if="testimonial" :test="testimonial" />
      <!-- widget START here -->
      <li v-for="p in ps" :key="p.id" class="widget">
        <div class="title">
          <h5>{{ p.name }}</h5>
        </div>
        <div class="content">
          <ul>
            <li>{{ p.name }}</li>
            <li v-if="p.current_price !== p.previous_price">
              <strike>${{ p.previous_price }}</strike>
            </li>
            <li>${{ p.current_price }}</li>
            <li style="margin-left: -8px; padding-top: 10px;">
              <purchase-button :package="p"></purchase-button>
              <!-- <paypal-button :package="p" size="medium" /> -->
            </li>
          </ul>
        </div>
      </li>
      <!-- widget END here -->
      <!-- widget END here -->
      <adsense
        ad-client="ca-pub-8213113866781504"
        ad-slot="7997332272"
        ad-style="display:inline-block;width:250px;height:250px"
        ad-format="auto"
      />
    </ul>
  </div>
</template>

<script>
import Package from "./package.vue";
import Testimonial from "./testimonial.vue";
// import {PACKAGES} from '../constants'
import PaypalButton from "./paypalButton.vue";
import PurchaseButton from "../components/purchaseButton.vue";
import Adsense from "../components/adsense.vue";
export default {
  components: {
    // package: Package,
    testimonial: Testimonial,
    // paypalButton: PaypalButton,
    purchaseButton: PurchaseButton,
    adsense: Adsense,
  },
  props: ["testimonial", "packages"],
  data() {
    return {};
  },
  computed: {
    ps() {
      if (!this.packages)
        return this.$store.getters.packagesBySport(
          "2343a835-82ae-4b4b-bb50-689912b97571"
        ).filter(p => !p.special);
      else return this.packages;
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// sidebar.vue?4fe50e35